import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { RadioGroup as RadioGroupPoi } from '@Sage/hoi-poi-ui';

function BooleanRadioGroup({ inputs, onChange, onBlur, ...props }) {
    const [options, setOptions] = useState([]);
    useEffect(() => {
        setOptions(inputs.map((input) => ({ label: input.label, value: input.name })));
    }, [inputs]);

    const onChangeRadioGroup = useCallback(
        (value) => {
            const values = inputs.reduce((obj, input) => {
                obj[input.name] = value === input.name;
                return obj;
            }, {});
            onBlur && onBlur(values);
        },
        [inputs, onBlur],
    );

    const value = useMemo(() => {
        const selectedInput = inputs.find((input) => props.value[input.name]);
        return selectedInput?.name;
    }, [inputs, props.value]);

    return (
        <RadioGroupPoi
            {...props}
            options={options}
            onChange={onChangeRadioGroup}
            value={value}
            isFullWidth={false}
        />
    );
}

export default BooleanRadioGroup;
